import { Sentry } from '../observability/sentry'
import '../observability/posthog'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/global.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Ocurrió un error inesperado.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
)
